export const ACTIVE_CLASS_NAME: string = 'active';
